export interface ViewSettings {
  pointBudget: number;
  pointDensity: number;
}
